import React from "react"
import { useParams } from "react-router-dom"
import styles from "./HostedBookingPage.module.css"

const HostedBookingPage = ({ experienceMode }) => {
  const { uuid, id } = useParams()
  const appOrigin = window.location?.origin || ""

  const iframeSrc = experienceMode
    ? `${appOrigin}/#/embedded/experience_detail/${uuid}/${id}`
    : `${appOrigin}/#/embedded/experience_listing/${uuid}`

  return (
    <div className={styles.overlay}>
      <div className={styles.modalContent}>
        <iframe
          src={iframeSrc}
          className={styles.iframe}
          title="Book Now"
          allow="payment *"
        />
      </div>
    </div>
  )
}

export default HostedBookingPage
